/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Save_Not_ListedInputs */



/**
* | output |
* | --- |
* | "The server no longer offers one of the selected models. Check again and choose from the list." |
*
* @param {Private_Models_Save_Not_ListedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_save_not_listed = /** @type {((inputs?: Private_Models_Save_Not_ListedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Save_Not_ListedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Server bietet eines der gewählten Modelle nicht mehr an. Prüfen Sie erneut und wählen Sie aus der Liste.")
	return /** @type {LocalizedString} */ ("The server no longer offers one of the selected models. Check again and choose from the list.")
});